// extracted by mini-css-extract-plugin
module.exports = {"container":"SettingsItem_container__1Xnku","header":"SettingsItem_header__3rIh5","selected":"SettingsItem_selected__ev_y7","option":"SettingsItem_option__1CdFg"};